export default __webpack_public_path__ + "static/media/consorcioLogo.dd356460.svg";